<template>
	<div id="startOutletPopover">
		<div v-if="this.productTypeModel?.selected?.outletKey || !this.productTypeModel?.selected"
			:class="this.productGroup?.outlet ? 'selected' : 'not-selected' "
			style="padding:5px;border-radius: 5px;padding-right:5px;padding-left:5px;color:white;">

			<div class="flexcenter" style="margin-left:2px;margin-right:2px;">


				<div v-if="!this.productTypeModel?.selected" class="link font-small"
					@click="this.toggleProductType(); this.$emit('closeMenus');" style="font-weight:bold;">
					Outlet</div>

				<!-- produkttyp är vald -->
				<div v-if="this.productTypeModel?.selected" class="link font-small"
					@click="this.$emit('closeMenus');this.setOutlet(null)" style="font-weight:bold;">Outlet</div>


				<!-- om ingen produkttyp är vald -->
				<div v-if="!this.productTypeModel?.selected" style="margin-left:3px;" @click="this.toggleProductType()">
					<Icon :fileName="this.showOutletProductType ? 'w3_chevron_up_red' : 'w3_chevron_down_red'"
						style="width:10px;height:10px;" />
				</div>

				<!-- badge som visar vald produkttyp -->
				<div v-if="this.debug && this.productTypeModel?.selected"
					style="background:black;margin-left:5px;color:white;padding:2px;padding-left:5px;padding-right:5px;font-size:80%;font-weight:bold;border-radius: 3px;margin-right:0px;"
					class="">
					{{ this.productTypeModel?.selected?.name }} </div>

			</div>

		</div>

		<!-- om produkttypen saknar outlet -->
		<div v-if="!this.productTypeModel?.selected?.outletKey && this.productTypeModel?.selected"
			style="padding:5px;border-radius: 5px;padding-right:5px;padding-left:5px;color:red;"
			:title="'Produkttypen ' + this.productTypeModel?.selected?.name + ' har ingen outlet.' ">
			<div style=" margin-left:2px;margin-right:2px;">
			<div class="font-small" style="color:grey;font-weight: bold;"> Outlet </div>
		</div>

	</div>

	<!-- productTyp dropdown -->
	<div v-if="this.showOutletProductType" style="background:var(--grey-3);"
		class="dropdown dropdown-w300 drop-shadow dropdown-p10" id="productTypeList"
		@mouseleave="this.$emit('closeOutletProductType');">

		<!-- listar produkttyper -->
		<div v-for="productType in this.productTypeModel?.list" :key="productType.key" class="flexcenter link productType"
			style="margin-bottom:5px;padding:5px;border-radius: 5px;"
			@click.stop="this.setProductTypeAndOutlet(productType);">

			<Circle style="margin-right:5px;" size="25px" :fileName="'w3_' + productType.urlKey + '_white'" hover=""
				color="--bg-message" />
			<b style="flex-grow:1;">{{ productType.label }}</b>

		</div>
		<Button v-if="this.debug" label="Alla" @click="this.setProductTypeNull()" />
		<div class="mobile">
			<div class="flexcenter" style="width:100%;justify-content: end;margin-top:10px;"
				@click.stop="this.$emit('closeOutletProductType');">
				<Circle fileName="w3_close_white" padding="25%" size="20px" color="--grey-5" style="margin-right:5px" />
			</div>
		</div>
	</div>
	</div>

</template>
<script>

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

import { routerMixin } from "@/mixins/routerMixin.js";
import { productMixin } from "@/mixins/productMixin.js";
import { productSearchMixin } from "@/mixins/productSearchMixin.js";
import { STORE_COMMIT, STORE_GETTER } from "../store/store";
import { PRODUCT_STORE_GETTER } from "../store/product-store";

export default {
	name: "StartOutletPopover",
	components: {},
	mixins: [routerMixin, productSearchMixin, productMixin],
	props: {
		showOutletProductType: Boolean
	},
	data() {
		return {
			
		};
	},
	computed: {

		get() {
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
			//return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return 1

		},

		productTypeModel() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL];
		},

		productListLoading(){
			return this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_LIST_LOADING];

		}

		//baseModel() {
		//	return this.$store.getters[STORE_GETTER.BASE_MODEL]
		//},


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });

		setOutlet(productType){


			if (!productType){
				productType = this.productTypeModel?.selected
			}

			if (productType?.outletKey){

				this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_GROUP_KEY, productType.outletKey);
				

				//console.log('FP: productType: ', productType);
				
				
			}

			const name = this.$route.name;

			if (name == "Products") {
				//alert(name);
				//this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType)
				//this.$router.replace("/" + productType.urlKey + "/products");
			} else {
				//this.routerShowProductList();
				this.$router.push("/" + productType.urlKey + "/products");


			}
		

		},

		setProductTypeAndOutlet(productType) {
			//this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType)
			//this.routerShowProductList()

			const name = this.$route.name;

			this.resetSearchProductConfig();

			// sätt rätt produktgrupp

			//outlet(productTypeKey, productGroupKey){

			this.setOutlet(productType)

			//

			this.$emit("closeOutletProductType");

			if (name == "Products"){
				//alert(name);
				this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType)
				this.$router.replace("/" + productType.urlKey + "/products");
			}else{
				//alert(name);
				this.$router.push("/" + productType.urlKey + "/products");
				
			}

			this.$emit("closeOutletProductType");
			
		},
		setProductTypeNull(){
			this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, null)
			this.$emit("closeOutletProductType");
		},
		toggleProductType(){

			if (this.showOutletProductType){
				this.$emit("closeOutletProductType");
			}else{
				this.$emit("showOutletProductType");
			}
		}


	},
	created() {

	}
};
</script>

<style scoped>
div#productTypeList div.productType{
	background: var(--grey-2);
}

div#productTypeList div.productType:hover {
	background: var(--grey-4);
}

div#startOutletPopover div.not-selected{
	/*background: var(--grey-2);*/
	background:transparent; 
}

div#startOutletPopover div.selected {
	background: var(--bg-error);
}

div#startOutletPopover div.not-selected div{
	color:var(--bg-error-solid);
}

div#startOutletPopover div.selected div {
	color: white;
}
</style>